import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ThemeTypography } from 'DesignSystem';
import React, { FC } from 'react';

interface ICatalogItemLinksProps {
  items: string[];
}

const Link = styled('a')(() => ({
  wordBreak: 'break-all',
}));

const CatalogItemLinks: FC<ICatalogItemLinksProps> = ({ items = [] }) => {
  return (
    <Box>
      <Box mb={1}>
        <ThemeTypography variant="BODY_LARGE_BOLD">Links</ThemeTypography>
      </Box>
      {items.map(link => (
        <Box key={link}>
          <Link href={link} key={link} target="_blank" rel="noreferrer">
            {link}
          </Link>
        </Box>
      ))}
    </Box>
  );
};

export default CatalogItemLinks;
